<template>
  <div class="col p-0">
    <ColorPointsHeader :message="pinkHeaderMessage" color="rgba(227, 13, 104, 0.5)" />
    <div class="row center">
      <div class="col-12 col-lg-8 offset-lg-2" v-html="focus.paragraphe1 ? focus.paragraphe1.texte : ''"></div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { getFocus } from '../../mixins/getFocus'

export default {
  name: 'Investir',
  mixins: [getFocus],
  components: {
    ColorPointsHeader: () => import('../../components/ColorPointsHeader')
  },
  data: function () {
    return {
      focus: {},
      pinkHeaderMessage: {
        titre: '',
        sousTitre: ''
      }
    }
  },
  async beforeMount () {
    await this.getFocus('Tolus Immo', 'Investir')
      .then(res => {
        this.focus = res
          this.pinkHeaderMessage.titre = this.focus.cartouche ? this.focus.cartouche.titre : ''
          this.pinkHeaderMessage.sousTitre = this.focus.cartouche ? this.focus.cartouche.texte : ''
      })
  }
}
</script>
